import { NextPage } from 'next'
import { useMemo } from 'react'
import { useRouter } from 'next/router'
import { useRedirectToMessenger } from '@ucheba/utils/hooks/useRedirectToMessenger'
import { EChatBotScenario, EMessengerType } from '@ucheba/store/chat-bot/types'
import { coreActions } from '@ucheba/store/core'
import { UCHEBA_SITE_NAME } from '@ucheba/utils/constants/core'
import { wrapper } from '../../../../store/store'

const TgSubscribeRegistrationPage: NextPage = () => {
  const { query } = useRouter()

  const siteName = useMemo(() => {
    return query.siteName ? String(query.siteName) : UCHEBA_SITE_NAME
  }, [query.siteName])

  const channelId = useMemo(() => {
    if (Array.isArray(query.channelId)) {
      return parseInt(query.channelId[0], 10)
    }

    return query.channelId ? parseInt(query.channelId, 10) : undefined
  }, [query])

  // сценарий для запуска
  const scenario = useMemo(() => {
    if (query.scenario) {
      if (Array.isArray(query.scenario)) {
        return query.scenario[0]
      }

      return query.scenario
    }

    return EChatBotScenario.vkSubscribe
  }, [query])

  const templateId = useMemo(() => {
    if (Array.isArray(query.templateId)) {
      return query.templateId[0]
    }

    return query.templateId
  }, [query])

  const payload = useMemo(() => {
    const params = { ...query }
    if (params.scenario) {
      delete params.scenario
    }

    if (params.templateId) {
      delete params.templateId
    }

    return params
  }, [query])

  useRedirectToMessenger(
    scenario,
    EMessengerType.telegram,
    channelId,
    templateId,
    siteName,
    payload
  )
  return null
}

TgSubscribeRegistrationPage.getInitialProps = wrapper.getInitialPageProps(
  (store) => async (): Promise<any> => {
    store.dispatch<any>(coreActions.toggleLayout(false))
  }
)

export default TgSubscribeRegistrationPage
